
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/year-of-the-sentence-writing-activities-every-student",
      function () {
        return require("private-next-pages/c/blog-posts/year-of-the-sentence-writing-activities-every-student.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/year-of-the-sentence-writing-activities-every-student"])
      });
    }
  